<template>
  <nd-dialog
    v-model="visible"
    :footer="false"
    class="template-popup"
    :closeBtn="detail.showCloseBtn === 'Y'"
    @close="closeAction"
  >
    <img :src="popDetail.smallIconUrl" class="top-image">
    <div
      class="content"
      :style="`background: url(${popDetail.backgroundUrl}) no-repeat center center; background-size: cover;`" 
    >
      <div v-html="detail.title" v-if="detail.title" class="title-container"></div>
      <div class="contentList-container" v-if="detail.contentList" v-html="detail.contentList"></div>
      <div class="smallContentList-container" v-if="detail.smallContentList" v-html="detail.smallContentList"></div>
      <div  class="continue">
        <div class="mark" :style="detail.buttonCorner" v-if="popDetail.buttonCorner">{{ popDetail.buttonCorner.content }}</div>
        <div class="btn STYLE_TWO" @click="continueAction" v-if="popDetail.mainButton.content" :style="detail.mainButton">{{ popDetail.mainButton.content }} </div>
      </div>
      <div @click="giveUpAction" v-if="popDetail.secondaryButton.content" class="give-up" :style="detail.secondaryButton">{{ popDetail.secondaryButton.content }}</div>
    </div>
  </nd-dialog>
</template>

<script>
export default {
  name: 'templatePopUp',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => ({})
    },
    popDetail: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    continueAction () {
      this.visible = false
    },
    closeAction () {
      this.$sensors.track('$WebClick', { content: '提现挽留弹窗关闭', loanPopType: this.detail.loanPopType, styleType: this.popDetail.styleType })
      this.continueAction()
    },
    giveUpAction () {
      this.visible = false
      this.$emit('onGiveUp')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.template-popup {
  /deep/.default-content {
    padding-top: 0;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 30px;
    .title-container {
      margin-top: 120px;
      display: flex;
    }
    .contentList-container,.smallContentList-container {
      margin-top: 5px;
      display: flex;
    }
    .continue {
      min-width: 360px;
      max-width: 90%;
      height: 80px;
      margin-top: 40px;
      position: relative;
      .btn {
        width: 100%;
        height: 100%;
        border-radius: 40px;
        font-size: 30px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 80px;
        text-align: center;
        padding:0 20px;
        background: linear-gradient( 90deg, #FF3333 0%, #FF5F34 100%);
      }
      .mark {
        position: absolute;
        right:0;
        top: -30px;
        border-radius: 20px 20px 20px 0px;
        padding:4px 15px;
      }
    }
    .give-up {
      margin-top: 27px;
      line-height: 33px;
      text-decoration: underline;
    }
  }
  img {
    &.top-image {
      position: absolute;
      top: -90px;
      left: 160px;
      width: 300px;
      height: 190px;
      text-indent: 80px;
    }
  }
}

</style>